<template>
  <div ref="view" class="course-unit-view">
    <ul class="clear-f">
      <li v-for="item in grades" :key="item.id" class="grade" @click="gradeClick(item)">
        <img :src="item.cover ? (resourceHost + item.cover) : gradeCover" alt="" @error="imgError"/>
        <div>{{item.name}}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import gradeCover from 'assets/image/grade-cover.jpg'
export default {
  name: 'courseUnit',
  data () {
    return {
      id: this.$route.params.id,
      grades: [],
      gradeCover,
      resourceHost: window.appConfig.resourceHost
    }
  },
  created () {
    this.getGrades()
  },
  methods: {
    getGrades () {
      // 获取面包屑导航
      this.$store.dispatch('setCourseNav', {id: this.id, idType: 1})
      // 获取级别数据
      this.$store.dispatch('setLoading')
      this.$http.get('course/grades?unitid=' + this.id)
        .then((response) => {
          this.$nextTick(() => {
            this.grades = response
          })
        })
        .catch(() => {
          this.$message.error('加载级别失败，请重试')
        })
        .then(() => {
          this.$store.dispatch('setLoading', false)
        })
    },
    gradeClick (grade) {
      this.$router.push({ path: '/course/grade/' + grade.id })
    },
    imgError (e) {
      e.target.src = gradeCover
    }
  },
  watch: {
    '$route.params.id': function (newId) {
      this.id = newId
      this.getGrades()
    }
  }
}
</script>

<style lang="scss">
.course-unit-view {
  .grade {
    position: relative;
    width: 150px;
    height: 180px;
    text-align: center;
    float: left;
    margin: 15px;
    cursor: pointer;
    img {
      height: 150px;
      width: 150px;
    }
    div {
      height: 30px;
      line-height: 35px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/course/unit.vue